export const UA_DEBUG_URL = 'https://www.google-analytics.com/analytics_debug.js';
export const UA_URL = 'https://www.google-analytics.com/analytics.js';
